exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mp-center[data-v-4342fce2]{align-items:center}", ""]);

// exports
